import { translate } from '../../Internationalization';
import ExternalAnchorButton from '../../../shared/ExternalAnchorButton';
import React from 'react';
import valuation from 'config/local/Widgets/valuation';

export default function EmbedFooter() {
	return (
		<footer>
			<p
				className="mb-4"
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{
					__html: translate(
						'agent.pages.widgets.lead_generation.embed.help_description'
					),
				}}
			/>

			<ExternalAnchorButton className="button" href={valuation.urls.help}>
				{translate(
					'agent.pages.widgets.lead_generation.embed.read_more'
				)}
			</ExternalAnchorButton>
		</footer>
	);
}
